// extracted by mini-css-extract-plugin
export var center = "_51-2";
export var clickableRow = "_51-5";
export var expandedRow = "_51-7";
export var hoverable = "_51-4";
export var left = "_51-1";
export var right = "_51-3";
export var row = "_51-0";
export var selectedRow = "_51-6";
export var summaryRow = "_51-8";